import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getInvestorDetailsByOrgId = createAsyncThunk(
  "profile/getInvestorDetailsByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getInvestorDetailsByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDropdownData = createAsyncThunk(
  "profile/getDropdownData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/business/getIndAtList");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const updateProfileDropdowns = createAsyncThunk(
  "profile/updateProfileDropdowns",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/api/business/updateProfileDropdowns`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllStates = createAsyncThunk(
  "profile/getAllStates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/business/getAllStates");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const updateAddressDetails = createAsyncThunk(
  "profile/updateAddressDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/api/business/updateAddressDetails`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changePassword = createAsyncThunk(
  "profile/changePassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/business/changePassword`, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllRelations = createAsyncThunk(
  "profile/getAllRelations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/business/getAllRelations`);
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addNomineeDetails = createAsyncThunk(
  "profile/addNomineeDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/business/addNomineeDetails`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getNomineeDetailsById = createAsyncThunk(
  "profile/getNomineeDetailsById",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getNomineeDetailsById?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateNomineeDetails = createAsyncThunk(
  "profile/updateNomineeDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/api/business/updateNomineeDetails`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEscrowDetailsByOrgId = createAsyncThunk(
  "profile/getEscrowDetailsByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getEscrowDetailsByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addSecondaryBank = createAsyncThunk(
  "profile/addSecondaryBank",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/business/addSecondaryBank`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const makeBankPrimary = createAsyncThunk(
  "profile/makeBankPrimary",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/business/makeBankPrimary`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeBank = createAsyncThunk(
  "profile/removeBank",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/business/removeBank`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBankDetailsByOrgId = createAsyncThunk(
  "profile/getBankDetailsByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getBankDetailsByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const verifyIfsc = createAsyncThunk(
  "profile/verifyIfsc",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/verifyIfsc", payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendOtp = createAsyncThunk(
  "profile/sendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/sendOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const validateOtp = createAsyncThunk(
  "profile/validateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/validateOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const editSendOtp = createAsyncThunk(
  "profile/editSendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/editSendOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const editValidateOtp = createAsyncThunk(
  "profile/editValidateOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/business/editValidateOtp",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getKycDetails = createAsyncThunk(
  "profile/getKycDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/business/getKycDetails`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendDepositDetails = createAsyncThunk(
  "profile/sendDepositDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/business/sendDepositDetails",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState: {
    loading: false,
    error: null,
    investorData: {},
    dropdownData: {},
    statesData: [],
    relations: [],
    nomineeDetailsData: {},
    bankDetailsData: [],
    addBankLoading: false,
    addBankError: null,
    ifscData: {},
    escrowDetailsData: {},
    kycDetailsData: {},
    otpData: {},
    editAddLoading: false,
    editAddError: null,
    validateOtpLoading: false,
    editDetailLoading: false,
    editDetailError: null,
    passChangeLoading: false,
    passChangeError: null,
    nomineeLoading: false,
    nomineeError: null,
    sendDepositLoading: false,
    sendDepositError: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getInvestorDetailsByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getInvestorDetailsByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.investorData = action.payload;
      state.error = null;
    });
    builder.addCase(getInvestorDetailsByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.investorData = [];
      state.error = action.payload;
    });

    builder.addCase(getAllStates.fulfilled, (state, action) => {
      state.statesData = action.payload;
    });

    builder.addCase(getDropdownData.fulfilled, (state, action) => {
      state.dropdownData = action.payload;
    });

    builder.addCase(getAllRelations.fulfilled, (state, action) => {
      state.relations = action.payload;
    });

    builder.addCase(updateAddressDetails.pending, (state) => {
      state.editAddLoading = true;
      state.editAddError = null;
    });
    builder.addCase(updateAddressDetails.fulfilled, (state, action) => {
      state.editAddLoading = false;
      state.editAddError = null;
    });
    builder.addCase(updateAddressDetails.rejected, (state, action) => {
      state.editAddLoading = false;
      state.editAddError = action.payload;
    });

    builder.addCase(getNomineeDetailsById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getNomineeDetailsById.fulfilled, (state, action) => {
      state.loading = false;
      state.nomineeDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getNomineeDetailsById.rejected, (state, action) => {
      state.loading = false;
      state.nomineeDetailsData = {};
      state.error = action.payload;
    });

    builder.addCase(getEscrowDetailsByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getEscrowDetailsByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.escrowDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getEscrowDetailsByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.escrowDetailsData = {};
      state.error = action.payload;
    });

    builder.addCase(verifyIfsc.pending, (state) => {
      state.error = null;
    });
    builder.addCase(verifyIfsc.fulfilled, (state, action) => {
      state.ifscData = action.payload.response;
      state.error = null;
    });
    builder.addCase(verifyIfsc.rejected, (state, action) => {
      state.ifscData = {};
      state.error = action.payload;
    });

    builder.addCase(addSecondaryBank.pending, (state) => {
      state.addBankLoading = true;
      state.addBankError = null;
    });
    builder.addCase(addSecondaryBank.fulfilled, (state, action) => {
      state.addBankLoading = false;
      state.addBankError = null;
    });
    builder.addCase(addSecondaryBank.rejected, (state, action) => {
      state.addBankLoading = false;
      state.addBankError = action.payload;
    });

    builder.addCase(makeBankPrimary.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(makeBankPrimary.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(makeBankPrimary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(removeBank.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(removeBank.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(removeBank.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getBankDetailsByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBankDetailsByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.bankDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getBankDetailsByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.bankDetailsData = [];
      state.error = action.payload;
    });

    builder.addCase(getKycDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getKycDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.kycDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getKycDetails.rejected, (state, action) => {
      state.loading = false;
      state.kycDetailsData = {};
      state.error = action.payload;
    });

    builder.addCase(sendOtp.pending, (state) => {
      state.error = null;
    });
    builder.addCase(sendOtp.fulfilled, (state, action) => {
      state.otpData = action.payload;
      state.error = null;
    });
    builder.addCase(sendOtp.rejected, (state, action) => {
      state.otpData = {};
      state.error = action.payload;
    });

    builder.addCase(validateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.error = null;
    });
    builder.addCase(validateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.error = null;
    });
    builder.addCase(validateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.error = action.payload;
    });

    builder.addCase(editSendOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.error = null;
    });
    builder.addCase(editSendOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.otpData = action.payload;
      state.error = null;
    });
    builder.addCase(editSendOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.otpData = {};
      state.error = action.payload;
    });

    builder.addCase(editValidateOtp.pending, (state) => {
      state.validateOtpLoading = true;
      state.error = null;
    });
    builder.addCase(editValidateOtp.fulfilled, (state, action) => {
      state.validateOtpLoading = false;
      state.error = null;
    });
    builder.addCase(editValidateOtp.rejected, (state, action) => {
      state.validateOtpLoading = false;
      state.error = action.payload;
    });

    builder.addCase(updateProfileDropdowns.pending, (state) => {
      state.editDetailLoading = true;
      state.editDetailError = null;
    });
    builder.addCase(updateProfileDropdowns.fulfilled, (state, action) => {
      state.editDetailLoading = false;
      state.editDetailError = null;
    });
    builder.addCase(updateProfileDropdowns.rejected, (state, action) => {
      state.editDetailLoading = false;
      state.editDetailError = action.payload;
    });

    builder.addCase(changePassword.pending, (state) => {
      state.passChangeLoading = true;
      state.passChangeError = null;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.passChangeLoading = false;
      state.passChangeError = null;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      state.passChangeLoading = false;
      state.passChangeError = action.payload;
    });

    builder.addCase(addNomineeDetails.pending, (state) => {
      state.nomineeLoading = true;
      state.nomineeError = null;
    });
    builder.addCase(addNomineeDetails.fulfilled, (state, action) => {
      state.nomineeLoading = false;
      state.nomineeError = null;
    });
    builder.addCase(addNomineeDetails.rejected, (state, action) => {
      state.nomineeLoading = false;
      state.nomineeError = action.payload;
    });

    builder.addCase(updateNomineeDetails.pending, (state) => {
      state.nomineeLoading = true;
      state.nomineeError = null;
    });
    builder.addCase(updateNomineeDetails.fulfilled, (state, action) => {
      state.nomineeLoading = false;
      state.nomineeError = null;
    });
    builder.addCase(updateNomineeDetails.rejected, (state, action) => {
      state.nomineeLoading = false;
      state.nomineeError = action.payload;
    });

    builder.addCase(sendDepositDetails.pending, (state) => {
      state.sendDepositLoading = true;
      state.sendDepositError = null;
    });
    builder.addCase(sendDepositDetails.fulfilled, (state, action) => {
      state.sendDepositLoading = false;
      state.sendDepositError = null;
    });
    builder.addCase(sendDepositDetails.rejected, (state, action) => {
      state.sendDepositLoading = false;
      state.sendDepositError = action.payload;
    });
  },
  reducers: {
    clearProfileError: (state) => {
      state.editAddError = null;
      state.addBankError = null;
      state.editDetailError = null;
    },
  },
});

export const { clearProfileError } = profileSlice.actions;

export default profileSlice.reducer;
